import script from "./program.vue?vue&type=script&setup=true&lang=js"
export * from "./program.vue?vue&type=script&setup=true&lang=js"

import "./program.vue?vue&type=style&index=0&id=9845e602&lang=css"

const __exports__ = script;

export default __exports__